// import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";

import { ErrorHandler } from "../core/ErrorApi/ErrorHandler";

export default {
    methods: {
        errorApi: function(err, handler) {
            if (handler == null) {
                handler = new ErrorHandler();
            }

            if (this.alertModal) {
                handler.setAlertModal(this.alertModal);
            }

            if (err.response && err.response.data && err.response.data.error) {
                var error = err.response.data.error;
                handler.errorCase(error);
            } else {
                if (this.alertModal != null) {
                    this.alertModal.clearText()
                        .setMsg("Network connection error!")
                        .show();
                }
                handler.errorCode(err);
            }
        },
    },
}
